import 'react-dates/initialize';
import React, { Component } from 'react';
import * as QueryString from 'query-string';

import { DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';

import {
	Popover, Menu, Button, Position, Text, Icon, Select,
} from 'evergreen-ui';
import moment from 'moment';
import 'moment/locale/pt-br';
import api from '../../../../services/api';
import TabletList from '../TableList';

import { BackofficeBriefingsList } from './style/BackofficeBriefingsList';
import { StyledDateRangePicker } from './style/StyledDateRangePicker';

export default class BriefingsList extends Component {
	formFilter = {
		query: {
			value: '',
		},
		startValue: {
			value: '',
		},
		endValue: {
			value: '',
		},
		productName: {
			comboI: false,
			comboII: false,
			comboIII: false,
		},
		wmArt: {
			wh: false,
			cliente: false,
			nao: false,
		},
		obs: {
			value: '',
		},
		startDate: '',
		endDate: '',
		demandStatus: {
			value: '',
		},
	};

	formOrder = {
		order: {
			value: '',
		},
	};

	state = {
		...this.formFilter,
		...this.formOrder,
		dataBriefings: [],
		demandStatuses: [
			{ id: '', title: 'Status' },
		],
	};

	constructor(props) {
		super(props);
		moment.locale('pt-BR');
	}

	componentDidMount() {
		const { history } = this.props;
		const params = QueryString.parse(history.location.search);

		this.setState({
			demandStatus: {
				value: params.status,
			},
		});
		api.get(`/briefings?status=${params.status}`)
			.then((response) => {
				this.setState({ dataBriefings: this.proccessBriefings(response.data.data) });
			});
		api.get('/demand-status')
			.then((response) => {
				this.setState({ demandStatuses: this.processStatuses(response.data.data) });
			});
	}

	onChange = (e) => {
		const state = {
			...this.state,
			[e.target.name]: {
				...this[e.target.name],
				value: e.target.value,
			},
		};

		if (e.target.name === 'startValue' || e.target.name === 'endValue') {
			return this.setState(state);
		}

		return this.setState(state, this.handleSubmit);
	};

	onChangeCheckbox = (e) => {
		if (e.target.name === 'product_name') {
			const { productName } = this.state;

			if (e.target.checked) {
				productName[e.target.id] = true;
				return this.setState({ productName }, this.handleSubmit);
			}

			productName[e.target.id] = false;
			return this.setState({ [productName[e.target.id]]: false }, this.handleSubmit);
		}

		if (e.target.name === 'wmArt') {
			const { wmArt } = this.state;

			if (e.target.checked) {
				wmArt[e.target.id] = true;
				return this.setState({ wmArt }, this.handleSubmit);
			}

			wmArt[e.target.id] = false;
			return this.setState({ [wmArt[e.target.id]]: false }, this.handleSubmit);
		}
		return '';
	};

	onChangeRadio = (e) => {
		const { obs } = this.state;

		if (e.target.name === 'obs') {
			obs.value = e.target.value;
			return this.setState({ obs }, this.handleSubmit);
		}

		return '';
	};

	onChangeDate = startDate => this.setState({ startDate }, this.handleSubmit);

	onChangeDate2 = endDate => this.setState({ endDate }, this.handleSubmit);

	cleanFilter = () => api.get('/briefings')
		.then(response => this.setState({
			dataBriefings: this.proccessBriefings(response.data.data),
			startDate: null,
			endDate: null,
			demandStatus: {
				value: '',
			},
		}));

	handleSubmit = () => {
		const {
			query, startDate, endDate, startValue, endValue, productName, wmArt, obs, order, demandStatus,
		} = this.state;

		const data = {
			query: query.value,
			start_date: startDate ? `${moment(startDate).format('YYYY-MM-DD')} 00:00:00` : '',
			end_date: endDate ? `${moment(endDate).format('YYYY-MM-DD')} 23:59:59` : '',
			product_name: [`${productName.comboI ? 'Combo I,' : ''}
			${productName.comboII ? 'Combo II,' : ''}${productName.comboIII ? 'Combo III' : ''}`],
			start_value: startValue.value ? parseFloat(startValue.value).toFixed(2) : '',
			end_value: endValue.value ? parseFloat(endValue.value).toFixed(2) : '',
			wm_art: [`${wmArt.wh ? 'sim_gb,' : ''}${wmArt.cliente ? 'sim_cliente,' : ''}${wmArt.nao ? 'nao,' : ''}`],
			obs: (obs.value === 'com'),
			status: demandStatus.value,
			sort: order.value,
		};

		const count = Object.keys(data).length;

		if ((moment(moment(startDate).format()).isAfter(moment(endDate).format()))) {
			return false;
		}

		return api.get(`/briefings?${this.convertToQueryParams(data, count)}`)
			.then(response => this.setState({
				dataBriefings: this.proccessBriefings(response.data.data),
			}));
	};

	convertToQueryParams = (data, count) => {
		let url = '';
		for (const key in data) {
			url += `${key}=${data[key]}`;
			url += (Object.keys(data).indexOf(key) < count - 1) ? '&' : '';
		}

		return url;
	};

	iconCaretDown = () => (
		<Icon
			className="icon-caret-down"
			icon="caret-down"
			color="muted"
			marginRight={16}
		/>
	);

	inputFilterDate = () => (
		<StyledDateRangePicker>
			<DateRangePicker
				startDate={this.state.startDate} // eslint-disable-line react/destructuring-assignment
				isOutsideRange={day => (moment().diff(day) < 0)}
				startDateId="your_unique_start_date_id" // PropTypes.string.isRequired
				endDate={this.state.endDate} // eslint-disable-line react/destructuring-assignment
				endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
				onDatesChange={({ startDate, endDate }) => this.setState({
					startDate,
					endDate,
				}, this.handleSubmit)} // PropTypes.func.isRequired,
				focusedInput={this.state.focusedInput} // eslint-disable-line react/destructuring-assignment
				onFocusChange={focusedInput => this.setState({
					focusedInput,
				})} // PropTypes.func.isRequired,
				startDatePlaceholderText="Data inicial"
				endDatePlaceholderText="Data final"
			/>
		</StyledDateRangePicker>
	);

	proccessBriefings = briefings => briefings.map((briefing) => {
		const brf = briefing;

		if (brf.product.channels) {
			brf.product.channels = briefing.product.channels.map((channel) => {
				const newChannel = { value: channel.value };
				if (channel.channel === 'googleDisplay') {
					newChannel.channel = 'GD';
				}
				if (channel.channel === 'googleSearch') {
					newChannel.channel = 'GS';
				}
				if (channel.channel === 'instagram') {
					newChannel.channel = 'IG';
				}
				if (channel.channel === 'facebook') {
					newChannel.channel = 'FB';
				}
				return newChannel;
			});

			brf.product.combo = brf.product.combo.split(' - ')[0];
		}

		return brf;
	});

	processStatuses = (statuses) => {
		const { demandStatuses } = this.state;
		const mappedStatuses = statuses.map((status) => {
			let tempStatus = {};
			if (status.type === 'demand_status') {
				tempStatus = {
					id: status.id,
					title: status.attributes.title,
				};
			}
			return tempStatus;
		});
		return [...demandStatuses, ...mappedStatuses];
	};

	inputFilterValue = () => {
		const { startValue, endValue } = this.state;
		return (
			<Popover
				position={Position.BOTTOM_LEFT}
				content={(
					<Menu>
						<div className="p-3" role="menuitem">
							<div className="form-group">
								<input
									type="number"
									className="form-control mb-2"
									id="minValue"
									aria-describedby="Mínimo"
									placeholder="Min"
									value={startValue.value}
									name="startValue"
									onChange={this.onChange}
								/>
								<input
									type="number"
									className="form-control mb-2"
									id="maxValue"
									aria-describedby="Máximo"
									placeholder="Máx"
									value={endValue.value}
									name="endValue"
									onChange={this.onChange}
								/>
								<button
									type="button"
									className="btn btn-secondary w-100"
									onClick={this.handleSubmit}
								>
									Aplicar
								</button>
							</div>
						</div>
					</Menu>
				)}
			>
				<Button className="btn btn-backoffice-gearbox mr-4 mb-3 mb-sm-3 mb-md-3 mb-lg-3 mb-xl-0">
					Valor
					{this.iconCaretDown()}
				</Button>
			</Popover>
		);
	};

	inputFilterCreative = () => {
		const { wmArt } = this.state;
		return (
			<Popover
				position={Position.BOTTOM_LEFT}
				content={(
					<Menu>
						<ul className="menu-combo p-3">
							<li>
								<div className="custom-control custom-checkbox" role="menuitem">
									<input
										type="checkbox"
										className="custom-control-input"
										name="wmArt"
										id="wh"
										onClick={this.onChangeCheckbox}
										checked={wmArt.wh}
									/>
									<label className="custom-control-label h5" htmlFor="wh">
										<Text size={500}>Sim, GB</Text>
									</label>
								</div>

								<div className="custom-control custom-checkbox" role="menuitem">
									<input
										type="checkbox"
										className="custom-control-input"
										name="wmArt"
										id="cliente"
										onClick={this.onChangeCheckbox}
										checked={wmArt.cliente}
									/>
									<label className="custom-control-label h5" htmlFor="cliente">
										<Text size={500}>Sim, cliente</Text>
									</label>
								</div>

								<div className="custom-control custom-checkbox" role="menuitem">
									<input
										type="checkbox"
										className="custom-control-input"
										name="wmArt"
										id="nao"
										onClick={this.onChangeCheckbox}
										checked={wmArt.nao}
									/>
									<label className="custom-control-label h5" htmlFor="nao">
										<Text size={500}>Não</Text>
									</label>
								</div>
							</li>
						</ul>
					</Menu>
				)}
			>
				<Button className="btn btn-backoffice-gearbox mr-4 mb-3 mb-sm-3 mb-md-3 mb-lg-3 mb-xl-0">
					Peça Gráfica
					{this.iconCaretDown()}
				</Button>
			</Popover>

		);
	};

	inputQueryFilter = () => {
		const { query } = this.state;
		return (
			<input
				type="text"
				name="query"
				className="form-control mb-4 input-txt"
				id="inputLojaVeiculos"
				placeholder="Digite a razão social, nome fantasia, CNPJ ou código pré-venda."
				value={query.value}
				onChange={this.onChange}
			/>
		);
	};

	inputStatusFilter = () => {
		const { demandStatuses } = this.state;
		const { demandStatus } = this.state;

		return (
			<Select
				className="selectOrder mr-4"
				id="selectOrder"
				width={160}
				name="demandStatus"
				onChange={this.onChange}
			>
				{demandStatuses.map(status => (
					<option value={status.id} selected={status.id === demandStatus.value}>
						{status.title}
					</option>
				))}
			</Select>
		);
	};

	inputOrderBy = () => (
		<Select
			className="selectOrder"
			id="selectOrder"
			width={160}
			name="order"
			onChange={this.onChange}
		>
			<option value="date:asc">Data - Menor</option>
			<option value="date:desc">Data - Maior</option>
			<option value="client_name:asc">Nome - A/Z</option>
			<option value="client_name:desc">Nome - Z/A</option>
			<option value="value:asc">Valor - Menor</option>
			<option value="value:desc">Valor - Maior</option>
			<option value="product_name:asc">Combo - Menor</option>
			<option value="product_name:desc">Combo - Maior</option>
		</Select>
	);

	render() {
		const { dataBriefings, demandStatuses } = this.state;
		const { history } = this.props;

		return (
			<BackofficeBriefingsList>
				<div className="table-list">
					<header>
						<i className="fa fa-bullhorn" />
						<strong>Demandas</strong>
					</header>
					<div className="filter mb-4">
						<h3 className="mb-2">
							<label htmlFor="inputLojaVeiculos">Buscar:</label>
						</h3>
						{this.inputQueryFilter()}

						<h3 className="mb-2">Filtrar por:</h3>

						{this.inputFilterDate()}
						{this.inputFilterValue()}
						{this.inputFilterCreative()}
						{this.inputStatusFilter()}

						<button
							type="button"
							className="btn btn-outline-dark btn-clear-filters mr-4 mb-3 mb-sm-3 mb-md-3 mb-lg-3 mb-xl-0"
							onClick={this.cleanFilter}
						>
							Limpar filtros
						</button>
					</div>

					<div className="order mb-4">
						<h3 className="mb-2">
							<label htmlFor="selectOrder">Ordenar por:</label>
						</h3>

						{this.inputOrderBy()}
					</div>

					<div className="table">
						<h3>Campanhas</h3>
						<TabletList
							dataThead={['Cliente:', 'CNPJ:', 'ID Pré-venda:', 'Data Pré-venda:', 'Status:']}
							dataTbody={dataBriefings}
							listStatus={demandStatuses}
							button={{ classButton: 'btn-secondary', value: 'Visualizar', onClick: briefing => history.push(`/backoffice/demandas/${briefing.id}/detalhes/1`) }}
						/>
					</div>
				</div>
			</BackofficeBriefingsList>
		);
	}
}
